import ActionType from 'store/_utils/classes/ActionType';

import type IActionType from 'store/_utils/interfaces/IActionType';
class DownloadTypes {
  static downloadFile: IActionType = new ActionType('DOWNLOAD/FILE');
  static validateDownloadHash: IActionType = new ActionType('DOWNLOAD/VALIDATE_HASH');
}

export default DownloadTypes;
